import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none",
  viewBox: "0 0 33 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      stroke: "#032E32",
      "stroke-width": ".25",
      d: "M23.385 7.926a1.37 1.37 0 0 1 1.338.351h-.001a1.36 1.36 0 0 1 .352 1.337l-4.09 14.517a1.36 1.36 0 0 1-1.21.994h-.119a1.37 1.37 0 0 1-1.234-.78h-.001l-3.137-6.634-6.636-3.135h-.001a1.379 1.379 0 0 1 .222-2.561h.001zM9.592 13.363l6.093 2.889 3.157-3.154a.748.748 0 1 1 1.053 1.061l-3.152 3.15 2.89 6.09L23.57 9.425z"
    }, null, -1)
  ])))
}
export default { render: render }